import { m2mStorageClient } from "./storage/client";

type Env = "development" | "production" | "local" | "localDev";

interface InitM2mComponentsArgs {
  env: Env;
}

export const initM2mComponents = (args: InitM2mComponentsArgs) => {
  m2mStorageClient.init({
    env: args.env === "production" ? "production" : "development",
  });
  globalThis.M2M_COMPONENTS_ENV ??= args.env;
};
